





































































import SdsAccountList from '@modules/userProfile/shared/components/SdsAccountList.vue';
import SdsAccountListItem from '@modules/userProfile/shared/components/SdsAccountListItem.vue';
import {
    SdsToggleSwitch,
    SdsButton,
    SdsInputCurrency,
} from '@superbet-group/web.lib.ui-components';
import {
    computed,
    defineComponent,
    onMounted,
    Ref,
    ref,
} from '@vue/composition-api';
import PreferencesStore from '@store/modules/ui/user/preferences/preferencesIndex';
import {
    isMobileLayout,
    useI18n,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import { PredefinedStake } from '@store/modules/ui/user/preferences/types';
import SdsPageHeader from '@shared/components/pageHeader/SdsPageHeader.vue';
import { capitalize } from '@superbet-group/web.lib.utilities';
import { RouteName } from '@src/app/router/constants/RouteName';
import { BreadcrumbItem } from '@shared/components/breadcrumbs/types';
import { usePredefinedStakes } from '@shared/betSlip/composables/predefinedStakes';
import { getConfig } from '@superbet-group/web.lib.config';
import { BetslipStore } from '@store/modules/ui/betSlip';
import PredefinedStakeButton from '@shared/betSlip/PredefinedStake.vue';

export default defineComponent({
    setup() {
        const minPredefinedStake = getConfig().betSlip.stakeMin;
        const maxPredefinedStake = Math.min(9_999, getConfig().betSlip.stakeMax);

        const { translate } = useI18n();
        const preferencesStore = useVuexStore<typeof PreferencesStore>('ui/user/preferences');
        const betSlipStore = useVuexStore<BetslipStore>('ui/sportOffer/betSlip');

        const setDeleteBetslipAfterPurchase = preferencesStore.action('setDeleteBetslipAfterPurchase');

        const indexOfEditedStake: Ref<null | number> = ref(0);
        function setEditedPredefinedStake(predefinedStake: PredefinedStake, index: number) {
            indexOfEditedStake.value = index;
            stakeValue.value = predefinedStake.value;
            initialStakeValue.value = predefinedStake.value;
        }

        const {
            sortedPredefinedStakes,
            firstPredefinedStake,
        } = usePredefinedStakes();

        const stakeValue = ref(firstPredefinedStake.value);
        const initialStakeValue = ref(firstPredefinedStake.value);

        const errorMessage = computed(() => {
            const parsedValue = stakeValue.value;

            if (Number.isNaN(parsedValue)) {
                return undefined;
            } else if (parsedValue < minPredefinedStake) {
                return translate('settings.betslip.error_stake_too_low', { minimum: minPredefinedStake }).toString();
            } else if (parsedValue > maxPredefinedStake) {
                return translate('settings.betslip.error_stake_too_high', { maximum: maxPredefinedStake }).toString();
            } else {
                return undefined;
            }
        });

        const isErrorState = computed(() => errorMessage.value != null);

        const setPredefinedStake = preferencesStore.action('setPredefinedStake');
        function saveNewPredefinedStake() {
            if (isErrorState.value && stakeValue.value) {
                return;
            }
            setPredefinedStake({ value: stakeValue.value, index: indexOfEditedStake.value });
            indexOfEditedStake.value = sortedPredefinedStakes.value.findIndex((stake) => stake.value === stakeValue.value);
            initialStakeValue.value = stakeValue.value;
        }

        const items = computed(() => [
            {
                label: 'settings.betslip.acceptAutoUpdateChanges',
                isToggled: betSlipStore.getter('autoUpdateChanges').value,
                onChange: () => {
                    betSlipStore.action('toggleAutoUpdateChanges')();
                },
            },
            {
                label: 'settings.betslip.deleteBetslipAfterPurchase',
                isToggled: preferencesStore.getter('deleteBetslipAfterPurchase').value,
                onChange: () => {
                    setDeleteBetslipAfterPurchase(!preferencesStore.getter('deleteBetslipAfterPurchase').value);
                },
            },
        ]);

        const breadcrumbs: BreadcrumbItem[] = [
            {
                label: capitalize(translate('settings')),
                to: {
                    name: RouteName.Account.Settings,
                },
            },
        ];

        // We do not allow decimals, so just ignore them
        function updateStakeValue(value: number): void {
            stakeValue.value = Math.floor(value);
        }

        onMounted(() => {
            window.scrollTo(0, 0);
        });

        return {
            items,
            sortedPredefinedStakes,
            indexOfEditedStake,
            stakeValue,
            initialStakeValue,
            errorMessage,
            isErrorState,
            title: capitalize(translate('headerTitle.settingsBetslip')),
            breadcrumbs,
            isMobile: computed(() => isMobileLayout()),

            capitalize,
            setEditedPredefinedStake,
            saveNewPredefinedStake,
            updateStakeValue,
        };
    },
    components: {
        SdsAccountList,
        SdsAccountListItem,
        SdsToggleSwitch,
        SdsInputCurrency,
        SdsButton,
        SdsPageHeader,
        PredefinedStakeButton,
    },
});
